/**
 * @description 定义一些常用的基础方法
 */
 export function noop() {}

 export function isDef(value) {
   return value !== undefined && value !== null;
 }
 
 export function isObj(x) {
   const type = typeof x;
   return x !== null && (type === "object" || type === "function");
 }
 
 export function get(object, path) {
   const keys = path.split(".");
   let result = object;
 
   keys.forEach(key => {
     result = isDef(result[key]) ? result[key] : "";
   });
 
   return result;
 }
 export function compareVersion(v1, v2) {
   v1 = v1.split(".");
   v2 = v2.split(".");
   var len = Math.max(v1.length, v2.length);
   while (v1.length < len) {
     v1.push("0");
   }
   while (v2.length < len) {
     v2.push("0");
   }
   for (var i = 0; i < len; i++) {
     var num1 = parseInt(v1[i]);
     var num2 = parseInt(v2[i]);
     if (num1 > num2) {
       return 1;
     } else if (num1 < num2) {
       return -1;
     }
   }
   return 0;
 }
 export function xzGetUrlParms(name) {
   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
   // 兼容获取不到参数的情况
   var regs = window.location.search
     ? window.location.search.substr(1)
     : window.location.href.split("#")[1].split("?")[1];
   var r = regs ? regs.match(reg) : null;
   if (r != null) return r[2];
   return null;
 }
 
 /**
  * @desc 判断是否在小程序中
  */
 
 export function isWechatMiniProgram() {
   let isWechat = /micromessenger/.test(ua);
   if (!isWechat) return false;
   //在微信中
   if (/miniProgram/i.test(ua) || window.__wxjs_environment === "miniprogram") {
     return true;
   } else if (xzGetUrlParms("flag") === "webChat") {
     //小程序环境
     return true;
   } else if (window.wx) {
     // eslint-disable-next-line no-undef
     wx.miniProgram.getEnv(function(res) {
       if (res.miniprogram) {
         //小程序环境
         return true;
       }
     });
   } else {
     return false;
   }
 }
 

 export function getStorageData(key) {
  const data = localStorage.getItem(key);
  if (data !== null) {
   if (data.indexOf('{') == 0 || data.indexOf('[') == 0) {
      return JSON.parse(data);
    } else {
      return data;
    }
  }
  const regex = new RegExp("(?:^|;)\\s?" + key + "=([^;]*)(?:;|$)");
  const matches = document.cookie.match(regex);
  try {
    if (matches && matches.length >= 2 && matches[1]) {
      if (matches[1].indexOf('{') === 0 || matches[1].indexOf('[') === 0) {
        try {
          const parsedData = JSON.parse(decodeURIComponent(matches[1]));
          return parsedData;
        } catch (error) {
          console.error('JSON parsing error:', error);
          return null;
        }
      } else {
        return matches[1];
      }
    } else {
      console.warn('No valid matches found.');
      return null;
    }
  } catch (error) {
    console.error('Unexpected error:', error);
    return null;
  }
}
export function setStorageData(key, value, time) {
  if (typeof value == 'object') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
  const Days = 30
  const exp = new Date()
  const expTime = !time ? Days * 24 * 60 * 60 * 1000 : time * 1000
  exp.setTime(exp.getTime() + expTime)
  const domain = process.env.NODE_ENV === "development" ? ';Domain=0.0.0.0' : ';Domain=.xiaozhu.com'
  console.log(domain);
  document.cookie = key + '=' + escape(JSON.stringify(value)) + ';expires=' + exp.toGMTString() + domain
}
export function removeStorageData(key) {
  localStorage.removeItem(key);
  const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  let cookieString = key + "=" + "; domain=.xiaozhu.com; " + expires;
  document.cookie = cookieString;
}


// WEBPACK FOOTER //
// ./src/utils/index.js